// @core/stores/billing/BillingReportStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { billingApi } from '@core/api';
import type {
  GetRevenueReportResponse,
  GetTrialBalanceResponse,
} from '@core/types/billing';

class BillingReportStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Get revenue report
   */
  async GetRevenueReport(params?: { currency?: string | number | boolean; period_end?: string | number | boolean; period_start?: string | number | boolean; }): Promise<GetRevenueReportResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await billingApi.GetRevenueReport(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get trial balance report
   */
  async GetTrialBalance(params?: { as_of?: string | number | boolean; }): Promise<GetTrialBalanceResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await billingApi.GetTrialBalance(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const billingReportStore = new BillingReportStore();
